import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {useModalPanelAdm} from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/modals/visible_modal";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";


const ModalsPanelAdm = observer(
    ({
         onRemoveCache,
         loading,
         onExternallyPay,
         onRefundPay,
         onAllowSubscriptionUpgrade
     }: {
        onRemoveCache: () => Promise<void>,
        onAllowSubscriptionUpgrade: () => Promise<void>,
        onExternallyPay: (payment: PaymentEntity) => void,
        onRefundPay: (payment: PaymentEntity) => void,
        loading: boolean,
    }) => {


        const {
            visibleModalRemoveCache, setVisibleModalRemoveCache,
            visibleModalExternallyPay, setVisibleModalExternallyPay,
            visibleModalRefund, setVisibleModalRefund,
            visibleModalAllowSubscriptionUpgrade, setVisibleModalAllowSubscriptionUpgrade
        } = useBetween(useModalPanelAdm);


        return (
            <>
                <ModalInformation
                    open={visibleModalRemoveCache}
                    onRequestClose={() => {
                        setVisibleModalRemoveCache(false);
                    }}
                    textHeaderModal={'Remover cache'}
                    textButton={'Remover'}
                    onRequestSave={async () => {
                        onRemoveCache().then();
                        setVisibleModalRemoveCache(false);
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={`Deseja realmente excluir o cache da empresa?`}
                    loading={loading}
                />

                <ModalInformation
                    open={visibleModalAllowSubscriptionUpgrade}
                    onRequestClose={() => {
                        setVisibleModalAllowSubscriptionUpgrade(false);
                    }}
                    textHeaderModal={'Permitir upgrade'}
                    textButton={'Permitir'}
                    onRequestSave={async () => {
                        onAllowSubscriptionUpgrade().then();
                        setVisibleModalAllowSubscriptionUpgrade(false);
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={`Deseja realmente permitir que faça um upgrade?`}
                    loading={loading}
                />

                <ModalInformation
                    open={visibleModalExternallyPay.visible}
                    onRequestClose={() => {
                        setVisibleModalExternallyPay({visible: false, payment: null});
                    }}
                    textHeaderModal={'Considerar como pago'}
                    textButton={'Pagar'}
                    onRequestSave={async () => {
                        onExternallyPay(visibleModalExternallyPay.payment!);
                        setVisibleModalExternallyPay({visible: false, payment: null});
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={`Deseja realmente considerar esta fatura como pago? Está ação só pode ser feita mediante a comprovante de pagamento.`}
                    loading={loading}
                />

                <ModalInformation
                    open={visibleModalRefund.visible}
                    onRequestClose={() => {
                        setVisibleModalRefund({visible: false, payment: null});
                    }}
                    textHeaderModal={'Estornar pagamento'}
                    textButton={'Estornar'}
                    onRequestSave={async () => {
                        onRefundPay(visibleModalRefund.payment!);
                        setVisibleModalRefund({visible: false, payment: null});
                    }}
                    nameIcon={ICONS_DROPDESK.info}
                    sizeIcon={130}
                    textInformation={`Deseja realmente estornar esse pagamento?`}
                    loading={loading}
                />
            </>
        )
    })
export default ModalsPanelAdm;
